import React from 'react';

interface IconCalendarProps {
    iconClasses?: string;
}

const IconCalendar: React.FC<IconCalendarProps> = ({ iconClasses }) => {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-calendar ${iconClasses ?? ''}`}
        >
            <path
                d="M15 0C16.6569 0 18 1.34315 18 3V15C18 16.6569 16.6569 18 15 18H3C1.34315 18 0 16.6569 0 15V3C0 1.34315 1.34315 0 3 0H15ZM2 4V15C2 15.5523 2.44772 16 3 16H15C15.5523 16 16 15.5523 16 15V4H2ZM13 6C13.5523 6 14 6.44771 14 7C14 7.5523 13.5523 8 13 8H5C4.44772 8 4 7.5523 4 7C4 6.44771 4.44772 6 5 6H13Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default IconCalendar;
